// Phase 5C — Recent Captures (browser-only).
// Stores up to 10 most recent Parts Assist captures in localStorage so the
// intake modal can offer quick re-prefill chips. ZERO server / DB / analytics.
//
// Safety: this is a pure UX convenience layer. Nothing here can mutate the DB,
// trigger the scheduler, or affect pricing. Worst case = stale local list.

const KEY = 'optibay:pa:recent';
const MAX = 10;

export interface RecentCapture {
  description: string;
  part_number: string | null;
  unit_cost: number | null;
  source_vendor: string | null;
  source_label: string | null;
  captured_at: string;
}

function safeParse(raw: string | null): RecentCapture[] {
  if (!raw) return [];
  try {
    const v = JSON.parse(raw);
    if (!Array.isArray(v)) return [];
    return v.filter((e) => e && typeof e === 'object' && typeof e.description === 'string');
  } catch {
    return [];
  }
}

export function loadRecentCaptures(): RecentCapture[] {
  if (typeof window === 'undefined') return [];
  try {
    return safeParse(window.localStorage.getItem(KEY));
  } catch {
    return [];
  }
}

export function pushRecentCapture(entry: RecentCapture): void {
  if (typeof window === 'undefined') return;
  try {
    const list = loadRecentCaptures();
    // Dedupe by description+part_number (case-insensitive).
    const key = `${entry.description.trim().toLowerCase()}|${(entry.part_number ?? '').trim().toLowerCase()}`;
    const filtered = list.filter(
      (e) =>
        `${e.description.trim().toLowerCase()}|${(e.part_number ?? '').trim().toLowerCase()}` !== key,
    );
    filtered.unshift(entry);
    window.localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, MAX)));
  } catch {
    /* localStorage full / disabled — silently ignore */
  }
}

export function clearRecentCaptures(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
